"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = exports.List = void 0;

var _react = _interopRequireDefault(require("react"));

var _list = require("./list.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var List = function List(props) {
  var color = props.color,
      children = props.children,
      rest = _objectWithoutProperties(props, ["color", "children"]);

  return /*#__PURE__*/_react.default.createElement(_list.ListStyled, _extends({
    $color: color
  }, rest), children);
};

exports.List = List;

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react.default.createElement(_list.ListItemStyled, rest, children);
};

exports.ListItem = ListItem;
List.defaultProps = {
  m: [0],
  p: [0],
  color: 'primaryDark',
  inline: false,
  measure: 'md'
};
ListItem.displayName = 'List.Item';
List.Item = ListItem;
List.Item.Style = _list.ListItemStyled;